// 上传图片时预览图片组件
<template>
  <div style="width: 100%" :style="'height:' + height">
    <el-row>
      <el-col :span="24"
        ><el-button
          :type="item.color || ''"
          :icon="item.icon"
          size="mini"
          v-for="(item, index) of verMenu"
          :key="index"
          :disabled="!item.edit"
          @click="handleMore(item.event)"
          >{{ item.name }}</el-button
        >
        <el-button icon="el-icon-zoom-in" :disabled="imgSrc === ''" @click="isFullScreen = true" size="mini"
          >放大图片</el-button
        >
      </el-col>
    </el-row>
    <div :class="isFullScreen ? 'fullScreenCss' : 'imgCard'" :style="'height:' + containerHeight">
      <img :src="imgSrc" v-if="imgSrc !== ''" />
      <div v-else><div>暂无图片</div></div>
      <!-- 全屏缩小按钮 -->
      <div class="shutFullScreen" @click="isFullScreen = false" v-show="isFullScreen">
        <i class="vxe-icon--zoomout" style="font-size: 20px; color: #666666"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    parentObj: Object,
    imgSrc: {
      type: String,
      default: ''
    },
    height: String,
    buttonList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      isFullScreen: false
    }
  },
  methods: {
    // 点击动态按钮
    handleMore(event) {
      if (this.parentObj.$options.methods[event]) {
        this.parentObj[event]()
      }
    }
  },
  computed: {
    // 横向扩展功能
    verMenu() {
      if (this.buttonList && this.buttonList.length > 0) {
        for (let item of this.buttonList) {
          if (!item.icon) {
            item['icon'] = 'el-icon-edit'
          }
        }
        return this.buttonList.filter(item => {
          return item.visible === undefined || item.visible === true
        })
      } else {
        return []
      }
    },
    // 图片高度
    containerHeight() {
      return this.height ? (Number(this.height.split('px')[0]) - 39) + 'px' : '100px'
    }
  }
}
</script>

<style lang="less" scoped>
.imgCard {
  overflow: auto;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  border: 2px dashed #cacdd5;
  div {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      text-align: center;
      font-size: 25px;
      font-weight: bold;
      color: #a8a8a8;
    }
  }
}
.imgCard:hover {
  border: 2px dashed #409eff;
}
.fullScreenCss {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100% !important;
  height: 100% !important;
  z-index: 100;
  background: #fff;
  overflow: auto;
}
.shutFullScreen {
  z-index: 101;
  position: fixed;
  right: 30px;
  top: 10px;
  width: 50px;
  height: 50px;
  border: #666666 solid 1px;
  opacity: 0.5;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.shutFullScreen:hover {
  opacity: 0.8;
  cursor: pointer;
  -webkit-transition: all 0.1s linear;
  -moz-transition: all 0.1s linear;
  -o-transition: all 0.1s linear;
  transition: all 0.1s linear;
}
.el-col {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 5px 0;
}
</style>
